import React from "react";
import {Link} from "react-router-dom";

interface Props {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}
interface State {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundary extends React.Component<Props, State> {
  state: State = {hasError: false};

  static getDerivedStateFromError(error: Error): State {
    return {hasError: true, error};
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("ErrorBoundary caught:", error, info);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;
      return (
        <div className="flex flex-col items-center justify-center min-h-[40vh] gap-4 text-center px-4">
          <div className="w-14 h-14 rounded-full bg-accent/10 border border-accent/20 flex items-center justify-center">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-accent">
              <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>
          </div>
          <div>
            <p className="text-t1 font-semibold mb-1">Something went wrong</p>
            <p className="text-t2 text-sm">{this.state.error?.message ?? "An unexpected error occurred."}</p>
          </div>
          <Link
            to="/movflix/"
            className="inline-flex items-center h-9 px-5 rounded-sm bg-accent text-white text-sm font-semibold transition-all duration-fast hover:bg-accent-hover"
          >
            Go home
          </Link>
        </div>
      );
    }
    return this.props.children;
  }
}
